function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { animated, useSpring } from 'react-spring';

function NivoSlice(props) {
  var to = props.to,
      from = props.from,
      config = props.config,
      delay = props.delay,
      style = props.style,
      src = props.src,
      imageStyle = props.imageStyle,
      onRest = props.onRest,
      onChange = props.onChange,
      onDelayEnd = props.onDelayEnd;
  var animateStyle = useSpring({
    to: to,
    from: from,
    config: config,
    delay: delay,
    onRest: onRest,
    onChange: onChange,
    onDelayEnd: onDelayEnd
  });
  return /*#__PURE__*/React.createElement(animated.div, {
    style: _objectSpread(_objectSpread({}, style), animateStyle),
    className: "nivo-slice"
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "image",
    style: imageStyle
  }));
}

NivoSlice.displayName = "NivoSlice";
export default NivoSlice;